import React, { useCallback } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationV2 = ({ currentPage = 1, pageSize = 10, totalItems = 0, onChangePage, isLoading = false }) => {
  const totalPages = Math.ceil((totalItems || 0) / (pageSize || 10)) || 1;

  const handlePageChange = useCallback((page, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof page === 'number' && !isNaN(page) && page > 0 && page <= totalPages) {
      onChangePage(page);
    }
  }, [onChangePage, totalPages]);

  const renderPages = useCallback(() => {
    if (isLoading) {
      return (
        <PaginationItem disabled>
          <PaginationLink href="#">...</PaginationLink>
        </PaginationItem>
      );
    }

    if (totalPages <= 0) {
      return null;
    }

    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      if (start > 2) pages.push("ellipsis-start");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < totalPages - 1) pages.push("ellipsis-end");

      pages.push(totalPages);
    }

    return pages.map((page, index) => {
      if (page === "ellipsis-start" || page === "ellipsis-end") {
        return (
          <PaginationItem key={index} disabled>
            <PaginationLink href="#">…</PaginationLink>
          </PaginationItem>
        );
      }
      return (
        <PaginationItem key={index} active={page === currentPage}>
          <PaginationLink 
            href="#"
            onClick={(e) => handlePageChange(page, e)}
          >
            {page}
          </PaginationLink>
        </PaginationItem>
      );
    });
  }, [currentPage, totalPages, handlePageChange, isLoading]);

  if (totalItems <= 0 || totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      aria-label="Page navigation"
      listClassName="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
    >
      <PaginationItem disabled={currentPage === 1 || isLoading}>
        <PaginationLink
          previous
          href="#"
          onClick={(e) => handlePageChange(currentPage - 1, e)}
        />
      </PaginationItem>
      {renderPages()}
      <PaginationItem disabled={currentPage === totalPages || isLoading}>
        <PaginationLink
          next
          href="#"
          onClick={(e) => handlePageChange(currentPage + 1, e)}
        />
      </PaginationItem>
    </Pagination>
  );
};

export default React.memo(PaginationV2);
